<template>
  <div>
    <b-table-simple
      ref="detailGrid"
      bordered
      responsive
      sticky-header
    >
      <colgroup>
        <col style="width: 150px">
        <col style="width: 100px">
        <col style="width: 100px">
        <col style="width: 100px">
        <col style="width: 100px">
        <col style="width: 100px">
        <col style="width: 100px">
      </colgroup>
      <b-thead head-variant="light">
        <b-tr>
          <b-th class="sticky-header">
            상세 코드
          </b-th>
          <b-th class="sticky-header">
            게시글 노출 수
          </b-th>
          <b-th>
            게시글 클릭 수
          </b-th>
          <b-th>
            시청 알림 팝업 노출 수
          </b-th>
          <b-th>
            시청 알림 팝업 클릭 수
          </b-th>
          <b-th>
            스케줄 알림 팝업 노출 수
          </b-th>
          <b-th>
            스케줄 알림 팝업 클릭 수
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody v-if="data.length > 0">
        <template v-for="(member, index) in data">
          <b-tr
            :key="`member-${member.entryCode}-${index}`"
          >
            <!-- <b-td
              v-if="index === 0"
              :rowspan="(member.length > 0 ? 2 : 0) + 1"
              contract-id
              style="left: 0"
            >
              {{ detail.contractName | $dateFormatter('YYYY-MM-DD') }}
            </b-td> -->
            <b-td>{{ member.entryCode }}</b-td>
            <b-td>{{ member.homePopupShowCount | $numberFormatter }}</b-td>
            <b-td>{{ member.homePopupClickCount | $numberFormatter }}</b-td>
            <b-td>{{ member.noticePopupShowCount | $numberFormatter }}</b-td>
            <b-td>{{ member.noticePopupClickCount | $numberFormatter }}</b-td>
            <b-td>{{ member.schedulePopupShowCount | $numberFormatter }}</b-td>
            <b-td>{{ member.schedulePopupClickCount | $numberFormatter }}</b-td>
          </b-tr>
        </template>

      </b-tbody>
      <b-tbody v-else>
        <b-tr>
          <b-td
            :colspan="7"
            class="text-center"
          >
            {{ contentId == null ? "게시글을 선택해 주세요" : "데이터가 없습니다" }}
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import {
  BTableSimple, BThead, BTbody, BTr, BTh, BTd,
} from 'bootstrap-vue'
import {
  onMounted, ref, watch, getCurrentInstance,
} from '@vue/composition-api'

export default {
  components: {
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  props: {
    contentId: {
      type: Number,
      required: false,
      default: null,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const instance = getCurrentInstance()
    const refs = instance.proxy.$refs

    const grandTotal = ref({
      homePopupShowCount: 0,
      homePopupClickCount: 0,
      noticePopupShowCount: 0,
      noticePopupClickCount: 0,
      schedulePopupShowCount: 0,
      schedulePopupClickCount: 0,
    })

    // const updateGrandTotal = () => {
    //   // grandTotal 초기화
    //   grandTotal.value = {
    //     contractId: 0,
    //     contractName: 0,
    //     entryCode: 0,
    //     hcpWorkPlaceCount: 0,
    //     dailyPopupCount: 0,
    //     buttonPopupCount: 0,
    //   }

    //   // 데이터를 누적하여 grandTotal에 추가
    //   const stats = props.data.statistics

    //   stats.forEach(detail => {
    //     detail.detailDepts.forEach(x => {
    //       grandTotal.value.contractId += x.contractId
    //       grandTotal.value.contractName += x.contractName
    //       grandTotal.value.entryCode += x.entryCode
    //       grandTotal.value.hcpWorkPlaceCount += x.hcpWorkPlaceCount
    //       grandTotal.value.dailyPopupCount += x.dailyPopupCount
    //       grandTotal.value.buttonPopupCount += x.buttonPopupCount
    //     })
    //   })
    // }

    watch(() => props.data, () => {
      // updateGrandTotal()

    })

    onMounted(() => {
      // 딜레이를 줘야 table border가 제대로 적용 됨
      setTimeout(() => {
        refs.detailGrid.$el.classList.add('custom-bordered')
      }, 500)
    })

    return {
      // grandTotal,
    }
  },
}
</script>

<style scoped>
.custom-bordered .table th, td {
  border: 1px solid #dee2e6;
}

.table th {
  vertical-align: middle;
}

.sticky-header {
  position: sticky;
  z-index: 99 !important;
}

.dark-layout .sticky-row {
  position: sticky;
  z-index: 3 !important;
  background-color: #283046;
}

.sticky-row {
  position: sticky;
  z-index: 3 !important;
  background-color: #fff;
}

.b-table-sticky-header {
  max-height: 650px;  /* table 15줄 이후 스크롤 */
}
</style>
